// extracted by mini-css-extract-plugin
export default {"containerDomainMailingLists":"DomainMailingLists_containerDomainMailingLists__whBYr"};